import styled, {css} from 'styled-components'

export const StyledWrapper = styled.div(
    ({theme: {palette}}) => css`
        display: grid;
        grid-template-rows: auto auto minmax(0, 1fr);
        background-color: ${palette.neutral.white};
        height: 100%;
        border-radius: 0 0 8px 8px;
        border: 1px solid ${palette.neutral[200]};
        border-top: none;
    `
)

export const StyledExportNameCell = styled.div(
    ({theme: {spacing, typography, palette}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 0.5}px;

        & > strong {
            ${typography.textSm};
            font-weight: 500;
            color: ${palette.neutral[900]};
        }

        & > span {
            ${typography.textXs};
            color: ${palette.neutral[600]};
        }
    `
)

export const StyledCreatedAtCell = styled.div(
    ({theme: {spacing, typography, palette}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 0.5}px;

        & > strong {
            ${typography.textSm};
            font-weight: 400;
            color: ${palette.neutral[900]};
        }

        & > span {
            ${typography.textXs};
            color: ${palette.neutral[600]};
        }
    `
)
